import {
  Card,
  ECardBorderRadiusSize,
  ECardMediaSize,
  Loader,
  SkeletonLine,
} from '@outdoorsyco/bonfire';
import React from 'react';

import { EBundledListingsTileOrientation } from './BookAnRVSuite';

interface IBundledListingsPlaceholderTileProps {
  orientation?: EBundledListingsTileOrientation;
}

export const BundledListingsPlaceholderTile = ({
  orientation = EBundledListingsTileOrientation.Vertical,
}: IBundledListingsPlaceholderTileProps) => {
  return (
    <ul
      className={`grid gap-6 md:gap-8 grid-cols-1 md:grid-cols-2 ${
        orientation === EBundledListingsTileOrientation.Vertical ? 'lg:grid-cols-3' : ''
      }`}>
      {Array.from({ length: 6 }).map((_, index) => {
        return (
          <li key={index}>
            <div
              className={`grid gap-4 grid-cols-1 ${orientation === EBundledListingsTileOrientation.Horizontal ? 'sm:grid-cols-2' : ''}`}>
              <Card
                borderRadiusSize={ECardBorderRadiusSize.Large}
                showHoverEffect={false}
                withBoxShadow={false}
                withTransparentBackground={true}>
                <Card.Media size={ECardMediaSize.Medium} fullRadius className="bg-gray-200">
                  <Loader className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" />
                </Card.Media>
              </Card>
              {orientation === EBundledListingsTileOrientation.Vertical ? (
                <div>
                  <div>
                    <SkeletonLine className="bg-gray-200" />
                    <SkeletonLine className="my-1 bg-gray-200" />
                    <SkeletonLine className="my-1 bg-gray-200" />
                  </div>

                  <div className="mt-4">
                    <SkeletonLine className="bg-gray-200" />
                  </div>
                </div>
              ) : (
                <div className="flex flex-col justify-between">
                  <div>
                    <SkeletonLine className="bg-gray-200" />
                    <SkeletonLine className="my-2 bg-gray-200" />
                    <SkeletonLine className="my-2 bg-gray-200 gap-4" />
                  </div>
                  <div>
                    <div className="flex flex-wrap items-center justify-between">
                      <SkeletonLine className="bg-gray-200" />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </li>
        );
      })}
    </ul>
  );
};
